import { render } from "./PublicOfficeLocations.vue?vue&type=template&id=d824c9e4"
import script from "./PublicOfficeLocations.vue?vue&type=script&lang=js"
export * from "./PublicOfficeLocations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__